

  /*====================================
  =        		TOGGLE DIVS            =
  ====================================*/

  if($('.toggle').length) {
    $('.toggle .toggle-titre').on('click', function() {
      var currentTab = $(this);
      $('.toggle-text.collapse.in').collapse('hide');
      $('.toggle-titre').not(currentTab).removeClass("opened");
      var target = currentTab.parent().find('.toggle-text');
      currentTab.toggleClass("opened");
      target.collapse(('toggle'));
    });
  }
 /*-----  End of TOGGLE DIVS  ------*/

 // ------------------------------ FANCYBOX --------------------------------------------//
  $(".fancybox").not(".media-link").fancybox({
    'type' : 'image',
    'transitionIn'  : 'elastic',
    'transitionOut' : 'elastic',
    'speedIn'   : 600, 
    'speedOut'    : 200, 
    'overlayShow' : true,
    helpers: {
              title : {
                  type : 'float'
              }
          }
  });
  $(".fancybox-video").fancybox({
    'transitionIn'  : 'elastic',
    'transitionOut' : 'elastic',
    'speedIn'   : 600, 
    'speedOut'    : 200, 
    'overlayShow' : true,
    helpers: {
              title : {
                  type : 'float'
              }
          }
  });

   // ---------------------------- fin fancybox --------------------------------------------//
